import { setFeaturePermissions } from './setFeaturePermissions';
import { proPermission } from './simplePermissions';

/** @deprecated  Do not call this method. This method was created to support legacy code, that set pro status in the front end.*/
export function legacySetPro() {
  setFeaturePermissions({ featurePermissions: proPermission });
}
